import ChartBarIcon from "@heroicons/react/24/solid/ChartBarIcon";
import CogIcon from "@heroicons/react/24/solid/CogIcon";
import UserIcon from "@heroicons/react/24/solid/UserIcon";
import UsersIcon from "@heroicons/react/24/solid/UsersIcon";
import ChatBubbleOvalLeftEllipsisIcon from "@heroicons/react/24/solid/ChatBubbleOvalLeftEllipsisIcon";
import BusinessIcon from "@mui/icons-material/Business";

export const routeManifest = [
  {
    capability: "canViewDashboard",
    path: "/",
    sidebarLabel: "Dashboard",
    sidebarIcon: ChartBarIcon,
  },
  {
    capability: "canManageUsers",
    path: "/users",
    sidebarLabel: "Users",
    sidebarIcon: UsersIcon,
  },
  {
    capability: "canManageUsers",
    path: "/add/users",
  },
  {
    capability: "canManageUsers",
    path: "/edit/users",
  },
  {
    capability: "canManageUsers",
    path: "/user/updatepassword",
  },
  {
    capability: "canManageClients",
    path: "/clients",
    sidebarLabel: "Clients",
    sidebarIcon: UserIcon,
  },
  {
    capability: "canManageClients",
    path: "/clients/add",
  },
  {
    capability: "canManageClients",
    path: "/clients/editclient",
  },
  {
    capability: "canViewBusinesses",
    path: "/business",
    sidebarLabel: "Business",
    sidebarIcon: BusinessIcon,
  },
  {
    capability: "canCreateBusinesses",
    path: "/business/add",
  },
  {
    capability: "canEditBusinesses",
    path: "/business/edit",
  },
  {
    capability: "canManageSettings",
    path: "/settings",
    sidebarLabel: "Settings",
    sidebarIcon: CogIcon,
  },
  {
    capability: "canViewConversationBrowser",
    path: "/conversations",
    sidebarLabel: "Conversations",
    sidebarIcon: ChatBubbleOvalLeftEllipsisIcon,
  },
  {
    capability: "canUseChatBotDemo",
    path: "/demo",
    sidebarLabel: "ChatBot",
    sidebarIcon: ChatBubbleOvalLeftEllipsisIcon,
  },
];
